import gsap, { Power3, Power4 } from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Ease } from '../_app/cuchillo/utils/Ease';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { Maths } from '../_app/cuchillo/utils/Maths';


export default class IndexBar {
  static container = GetBy.id('IndexBar');
  static holder = GetBy.class('holder', this.container)[0];

  static ON_SHOW = "onshow";
  static ON_SHOW_END = "onshowend";
  static ON_HIDE = "onhide";
  static ON_HIDE_END = "onhideend";
  static STATE_OPEN = "OPEN";
  static STATE_CLOSE = "CLOSE";
  static _state;
  static _progress;
  static size = {
    open:0,
    height:0,
    scroll:0,
    delta:0
  };

  static get height() { return this.size.height; }
  static set height(__height) {
    this.size.height = __height;
    document.body.style.setProperty('--index-height', `${this.size.height}px`);
  }

  static get progress() { return this._progress; }
  static set progress(__height) {
    this._progress = __height;
    //document.body.style.setProperty('--progress', `${this._progress}`);
    document.body.style.setProperty('--progress-index', `${this._progress}`);
  }

  static get isOpen() { return this._state === IndexBar.STATE_OPEN; }
  static get state() { return this._state };
  static set state(__state) {
    if(this._state === __state) return;
    this._state = __state;
  }

  static nav = GetBy.id("IndexBarNav");
  static items = [];
  static total = 0;

  static init () {
    this.resize();
    IndexBar.directHide();
  }

  static toggleState() {
    if(!this.isOpen) this.show();
    else this.hide();
  }

  static reset() {
    this.progress = 0;
    this.total = 0;
    this.size.open = this.holder.offsetHeight;
    this.nav.innerHTML = '<span class="fake"></span>';
    this.items = [];

    GetBy.selector("[data-index-item]").forEach(dom => {
      const id = dom.id;
      const titleElement = dom.querySelector('.title');
      const textElement = dom.querySelector('.body-default') || dom.querySelector('.blockquote');

      let strTitle = dom.querySelector('.title')? titleElement.textContent.trim() : "";
      strTitle = textElement? strTitle + ": " + textElement.textContent.trim() : strTitle;

      const title = strTitle ? strTitle : 'Unknow section';
  
      const link = document.createElement('a');
      link.href = `#${id}`;
  
      const spanText = document.createElement('span');
      spanText.className = 'text';
      spanText.textContent = title;
  
      const spanEmpty = document.createElement('span');
  
      link.appendChild(spanText);
      link.appendChild(spanEmpty);
      this.nav.appendChild(link);

      this.total = this.items.push({
        dom,
        link,
        progressBar:0,
        domSize: {
          pos0:0,
          pos1:0
        },
        linkSize: {
          pos0:0,
          pos1:0
        },
      });
    });   
    
    this.updateSizes();
  }

  static updateSizes() {
    let offsetLast = 1;

    for(let i=0; i<this.total; i++) {
      const item = this.items[i];
      const next = this.items[i+1]? this.items[i+1] : {dom:GetBy.id("NextProject")};
      offsetLast = this.items[i+1]? 1 : 0;

      const domRect = item.dom.getBoundingClientRect();
      const linkRect = item.link.getBoundingClientRect();
      const nextDomRect = next.dom.getBoundingClientRect();
      
      this.items[i].domSize.pos0 = i == 0? 0 : domRect.top + Scroll.y - Metrics.OFFSET * 1.2;
      this.items[i].domSize.pos1 = nextDomRect.top + Scroll.y - Metrics.OFFSET * 1.2 * offsetLast;
      this.items[i].linkSize.pos0 = i == 0? 0 : linkRect.left;
      this.items[i].linkSize.pos1 = i == this.total-1? Metrics.WIDTH : linkRect.right;
      this.items[i].progressBar = (this.items[i].linkSize.pos1 - this.items[i].linkSize.pos0)/Metrics.WIDTH;
    }
  }

  static show(__d = 0) {
    this.reset();

    this.container.style.visibility = 'visible';
    this.container.setAttribute('aria-expanded', 'true');
    this.state = IndexBar.STATE_OPEN;
    this.show__effect();
  }

  static afterShow() {}

  static show__effect(__d = 0) {
    gsap.to(this, { height:this.size.open, duration:1, ease: Ease.EASE_CUCHILLO_OUT, delay:.0,
      onComplete: () => {
        this.afterShow();
      }
    });
  }

  // HIDE
  static hide(__d = 0) {
    this.state = IndexBar.STATE_CLOSE;
    this.items = [];
    this.total = 0;
    this.hide__effect();
  }

  static directHide() {
    this.height = 0;
    this._state = IndexBar.STATE_CLOSE;
    this.afterHide();
  }

  static hide__effect(__d = 0) {
    gsap.to(this, { height:0, duration:.4, ease: Power4.easeOut, delay:.0,
      onComplete: () => {
        this.afterHide();
      }
    });
  }

  static afterHide() {
      this.container.style.visibility = 'hidden';
      this.container.setAttribute('aria-expanded', 'false');
      this.reset();
  }

  static loop() {
    if(!this.items[0]) return;
    //const p = (Scroll.y/this.items[0]?.domSize.pos1) * this.items[0]?.progressBar;


    //console.log(this.items[0]?.progressBar, p)
   // this.progress = p;
    let progress = 0;
    let p = 0;
    for(let i=0; i<this.total; i++) {
      if(i==this.total-1) {
        p = Math.max(0,Maths.normalize(this.items[i].domSize.pos1, this.items[i].domSize.pos0, Scroll.y));
        if(p >= 1) {
          p = p;
        }
      } else {
        p = Math.min(1,Math.max(0,Maths.normalize(this.items[i].domSize.pos1, this.items[i].domSize.pos0, Scroll.y)));
      }
      
      progress = progress + this.items[i].progressBar * p;

      //this.items[i].link.innerHTML = p;//Scroll.y / this.items[i].domSize.pos1//this.items[i].domSize.pos1/Scroll.y;
    }
    
    this.progress = progress;
  }
  
  static resize() {
    this.size.open = this.holder.offsetHeight;
    this.updateSizes();
  }
}
